// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__P9FVI","label":"Radio_label__1D5nx","checkMark":"Radio_checkMark__2kLwf","disabled":"Radio_disabled__qOtBB"};